import { useSyncExternalStore } from "react"
import { getUnreadCount } from "../services/messageService"

const REFRESH_MS = 60_000
const CHANGED_EVENT = "messages-changed"

// One number for the whole app: the badge in the menu and the bell in the top
// bar read the same value and share a single request per minute.
let unread = 0
let timer: number | undefined
const listeners = new Set<() => void>()

async function refresh() {
  try {
    const result = await getUnreadCount()
    if (result && result.unread !== unread) {
      unread = result.unread
      listeners.forEach((listener) => listener())
    }
  } catch {
    // The badge is a hint: a failed request leaves the last number in place
  }
}

function subscribe(listener: () => void) {
  listeners.add(listener)

  if (listeners.size === 1) {
    refresh()
    timer = window.setInterval(refresh, REFRESH_MS)
    window.addEventListener(CHANGED_EVENT, refresh)
  }

  return () => {
    listeners.delete(listener)

    if (listeners.size === 0) {
      window.clearInterval(timer)
      window.removeEventListener(CHANGED_EVENT, refresh)
    }
  }
}

// Tells the badge and the bell that messages were read or arrived
export function announceMessagesChanged() {
  window.dispatchEvent(new Event(CHANGED_EVENT))
}

// Number of unread messages, refreshed every minute and whenever the inbox changes
export function useUnreadMessages() {
  return useSyncExternalStore(subscribe, () => unread)
}
